/* eslint-disable */
import React from 'react'
import Page from '../../Component/Pagination/Pagination'
import Loader from '../loaders/loader'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import {message} from 'antd'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import $ from 'jquery'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import cookie from 'react-cookies'
import BASE_REPORT from '../BaseComponent/BASEREPORT'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'

class AllCars extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      paginationList: [],
      printInfo: [],
      lengthProducts: 0,
      pageNumber: 1,
      modalDelete: false,
      carType: []
    }
  }

  getAllCars = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal'),
    sort = sessionStorage.getItem('sortBy')
  ) => {
    http
      .get(`car/manage/report?export=false&pageSize=${pageSize}&pageNumber=${pageNumber}&${params}&sortBy=${sort}`, {})
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            paginationList: response.data.object.result,
            lengthProducts: response.data.object.countAll
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    http
      .get(`${BASE_REPORT.BASE_REPORT_CAR}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            carType: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    this.getAllCars()
  }

  onResultFetched(data) {
    this.setState({
      paginationList: data
    })
  }

  changeDropDown(data) {
    this.setState({
      paginationList: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  deleteCar = (numId) => {
    let carId = this.state.paginationList[numId].carId
    let carName = this.state.paginationList[numId].name
    sessionStorage.setItem('carId', carId)
    sessionStorage.setItem('carName', carName)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }
  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('carId')
    sessionStorage.removeItem('carName')
  }

  deleteOk = () => {
    let carId = sessionStorage.getItem('carId')
    let data = {
      carId: carId
    }
    // alert(JSON.stringify(data))
    http
      .post(`car/manage/delete`, data, {})
      .then((response) => {
        if (response.data.error == null) {
          this.getAllCars()

          message.success('خودرو با موفقیت حذف شد')
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          // message.error(('خطای ' + response.data.errorCode + ' : ' + response.data.description));
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    var type = $('#type').val()
    var color = $('#color').val()
    var yearMin = this.convertDigit($('#yearMin').val())
    var yearMax = this.convertDigit($('#yearMax').val())
    var capacityMin = this.convertDigit($('#capacityMin').val())
    var capacityMax = this.convertDigit($('#capacityMax').val())
    var plateNumber = this.convertDigit($('#plateNumber').val())
    var plateText = $('#plateText').val()
    sessionStorage.setItem(
      'params',
      `type=${type}&color=${color}&yearMin=${yearMin}&yearMax=${yearMax}&capacityMin=${capacityMin}&capacityMax=${capacityMax}&plateNumber=${plateNumber}&plateText=${plateText}`
    )
    this.getAllCars()
  }

  exportExcel = () => {
    http
      .get(`car/manage/report?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['plate'] = ' ایران ' + excelReport[i]['plateNumber'] + ' - ' + excelReport[i]['plateText']
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`car/manage/report?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            printInfo: response.data.object.result
          })
          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            printInfo: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  render() {
    const {lengthProducts} = this.state
    const carName = sessionStorage.getItem('carName')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let excelColumns = [
      {title: 'نام', value: 'name'},
      {title: 'رنگ', value: 'color'},
      {title: 'مدل', value: 'year'},
      {title: 'ظرفیت', value: 'capacity'},
      {title: 'شماره پلاک', value: 'plateNumber'},
      {title: 'سریال پلاک', value: 'plateText'}
    ]

    let name = cookie.load('name')
    let columns = ['ردیف', 'نام', 'رنگ ', 'مدل', 'ظرفیت', 'پلاک']
    return (
      <div className="rtl printA4Page">
        <div className="printSection ">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست خودرو ها"
              headerColSpan={6}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((cars, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{cars.name}</td>
                  <td>{cars.color}</td>
                  <td>{cars.year}</td>
                  <td>{cars.capacity}</td>
                  <td>{'ایران' + cars.plateNumber + ' - ' + cars.plateText}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="لیست خودرو ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'name'}
                field={'name'}
                title={'نام'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'code'}
                field={'code'}
                title={'کد'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'color'}
                field={'color'}
                title={'رنگ'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'year'}
                field={'year'}
                title={'سال'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'capacity'}
                field={'capacity'}
                title={'مدل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'plate'}
                field={'plate'}
                title={'پلاک'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>خودرو ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/AddCar"
                  printUrl=""
                  url="car/manage/report"
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl="car/manage/report/?export=true"
                  excelColumns={excelColumns}
                  titleAdd="افزودن خودرو"
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>نوع</label>
                  <select className="form-control" id="type">
                    <option value="">-----</option>
                    {this.state.carType.map((carType, index) => (
                      <option key={index} value={carType.id}>
                        {carType.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formComponent">
                  <label>رنگ</label>
                  <input className="form-control" id="color" type="text" />
                </div>
                <div className="formComponent">
                  <label>مدل از</label>
                  <input className="form-control" id="yearMin" type="text" />
                </div>
                <div className="formComponent">
                  <label>مدل تا</label>
                  <input className="form-control" id="yearMax" type="text" />
                </div>
                <div className="formComponent">
                  <label>ظرفیت از</label>
                  <input className="form-control" id="capacityMin" type="text" />
                </div>

                <div className="formComponent">
                  <label>ظرفیت تا</label>
                  <input className="form-control" id="capacityMax" type="text" />
                </div>

                <div className="formComponent">
                  <label>شماره سمت راست پلاک</label>
                  <input className="form-control" id="plateNumber" type="text" />
                </div>

                <div className="formComponent">
                  <label>شماره سمت چپ پلاک</label>
                  <input className="form-control" id="plateText" type="text" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام</td>
                    <td>رنگ</td>
                    <td>مدل</td>
                    <td>ظرفیت</td>
                    <td>پلاک</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>
                  {Array.isArray(this.state.paginationList) &&
                    this.state.paginationList.map((cars, index) => (
                      <tr key={index}>
                        <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                        <td>{cars.name}</td>
                        <td>{cars.color}</td>
                        <td>{cars.year}</td>
                        <td>{cars.capacity}</td>
                        <td>{'ایران' + cars.plateNumber + ' - ' + cars.plateText}</td>
                        <td>
                          <Link to={`EditCar/${cars.carId}`}>
                            <img src={require('../../image/editDriver.svg')} alt="" />
                          </Link>
                        </td>
                        <td>
                          <button onClick={() => this.deleteCar(index)}>
                            <img src={require('../../image/trash.svg')} alt="" />
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={lengthProducts}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url="car/manage/report"
                />
              </div>
            </div>
          </div>

          <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
            <ModalHeader toggle={this.deleteCancel}>حذف نوع خودرو</ModalHeader>
            <ModalBody>
              <p className="titleSm">آیا از حذف خودروی {carName} مطمئن هستید؟؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.deleteOk}>
                حذف خودرو
              </button>
              <button className="cancelBtnModal" onClick={this.deleteCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default AllCars
